import 'react-day-picker/style.css'
import './react-day-picker.css'
import { lazy, Suspense, useMemo } from 'react'

import { CustomComponents } from 'react-day-picker'

import { DateTooltipContext, GetDateTooltipFn } from './DateTooltipContext'
import DayButtonWithTooltip from './DayButtonWithTooltip'

const DayPicker = lazy(async () => {
  const module = await import('react-day-picker')
  return { default: module.DayPicker }
})

type CalendarProps = React.ComponentProps<typeof DayPicker> & {
  getDateTooltip?: GetDateTooltipFn
}

const Calendar = ({ getDateTooltip, ...props }: CalendarProps) => {
  const components: Partial<CustomComponents> | undefined = useMemo(
    () => (getDateTooltip ? { DayButton: DayButtonWithTooltip } : undefined),
    [getDateTooltip]
  )

  const calendar = (
    <Suspense>
      <DayPicker showOutsideDays components={components} {...props} />
    </Suspense>
  )

  if (getDateTooltip) {
    return (
      <DateTooltipContext.Provider value={getDateTooltip}>{calendar}</DateTooltipContext.Provider>
    )
  }

  return calendar
}

export default Calendar
